import zreportapi from "../../../services/zreport";

// Banks
export const fetchBanksApi = async () => {
  const response = await zreportapi.get("DefinitionBanks?page=1&size=100");
  return response.data;
};
export const addBankApi = async (title) => {
  const response = await zreportapi.post("DefinitionBanks", { title });
  return response.data;
};
export const updateBankApi = async (id, title) => {
  const response = await zreportapi.put(`DefinitionBanks/${id}`, { title });
  return response.data;
};
export const deleteBankApi = async (id) => {
  const response = await zreportapi.delete(`DefinitionBanks/${id}`);
  return response.data;
};

// Debts
export const fetchDebtsApi = async () => {
  const response = await zreportapi.get("DefinitionDebts?page=1&size=100");
  return response.data;
};
export const addDebtApi = async (title) => {
  const response = await zreportapi.post("DefinitionDebts", { title });
  return response.data;
};
export const updateDebtApi = async (id, title) => {
  const response = await zreportapi.put(`DefinitionDebts/${id}`, { title });
  return response.data;
};
export const deleteDebtApi = async (id) => {
  const response = await zreportapi.delete(`DefinitionDebts/${id}`);
  return response.data;
};

// Expenses
export const fetchExpensesApi = async () => {
  const response = await zreportapi.get("DefinitionExpenses?page=1&size=100");
  return response.data;
};
export const addExpenseApi = async (title) => {
  const response = await zreportapi.post("DefinitionExpenses", { title });
  return response.data;
};
export const updateExpenseApi = async (id, title) => {
  const response = await zreportapi.put(`DefinitionExpenses/${id}`, { title });
  return response.data;
};
export const deleteExpenseApi = async (id) => {
  const response = await zreportapi.delete(`DefinitionExpenses/${id}`);
  return response.data;
};

// Cases
export const fetchCasesApi = async (branchId) => {
  const response = await zreportapi.get(`DefinitionCases/branch/${branchId}?page=1&size=100`);
  return response.data;
};
export const addCaseApi = async (title) => {
  const response = await zreportapi.post("DefinitionCases", { title });
  return response.data;
};
export const updateCaseApi = async (id, title) => {
  const response = await zreportapi.put(`DefinitionCases/${id}`, { title });
  return response.data;
};
export const deleteCaseApi = async (id) => {
  const response = await zreportapi.delete(`DefinitionCases/${id}`);
  return response.data;
};

// Cashiers
export const fetchCashiersApi = async (branchId) => {
  const response = await zreportapi.get(`DefinitionCashiers/branch/${branchId}?page=1&size=100`);
  return response.data;
};
export const addCashierApi = async (name, surname) => {
  const response = await zreportapi.post("DefinitionCashiers", { name, surname });
  return response.data;
};
export const updateCashierApi = async (id, name, surname) => {
  const response = await zreportapi.put(`DefinitionCashiers/${id}`, { name, surname });
  return response.data;
};
export const deleteCashierApi = async (id) => {
  const response = await zreportapi.delete(`DefinitionCashiers/${id}`);
  return response.data;
};
